import clsx from "clsx";
import { FULL_LOGO_HEIGHT, FullLogoIcon, LogoPurpleIcon } from "./FullLogo.styles";
import { useColor } from "@commonlibs";
import ConditionalLink from "ui/router/components/ConditionalLink/ConditionalLink";
import { FullLogoProps } from "./FullLogo.types";
import { MainRoutes } from "ui/common/router/MainRouter.types";

export default function FullLogo({
    size = "md",
    link = MainRoutes.MAIN,
    className,
    style,
    color: colorProp = "white",
    variant = "white",
}: FullLogoProps): JSX.Element {
    const height = FULL_LOGO_HEIGHT[size];
    const color = useColor(colorProp) as string;

    return (
        <ConditionalLink condition={Boolean(link)} to={link || MainRoutes.MAIN} className={clsx("full-logo", className)} style={style}>
            {variant === "white" && <FullLogoIcon height={height} color={color} />}
            {variant === "purple" && <LogoPurpleIcon height={height} color={color} />}
        </ConditionalLink>
    );
}
